import React, { useState } from "react";
import { Loader } from '../../components';
import { ContactStepsIndicator, BookDemoWrap } from '../../components';
import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { useDispatch } from "react-redux";
import { useLocation,useHistory } from 'react-router-dom';

const BookDemoContainer = (props) => {
  document.title = "Contact Invrsion";
  const [currentIndex, setCurrentIndex] = useState(0);
  const [indexBack, setindexBack] = useState(null);
  const location = useLocation();
  const dispatch = useDispatch();
  let history = useHistory();

  const tazza = require("../../assets/image-form.png");
  const arrayLoad = [
    tazza
  ];

  const nextStep = (index)  => {
    console.log(index !== undefined);
    
    if(index !== undefined) {
      if(index < currentIndex) {
        setindexBack(index)
        setCurrentIndex(index)
      }
    } else {
      setCurrentIndex(currentIndex + 1)
    }
  }

  const clickClose = (slug) => {
    if(history.location.pathname !== slug){
      dispatch(setLoader(true))
      

      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        window.history.back();
      }, 500);
    }
    
  }
  return (
    <React.Fragment>
      <div className="close-back" onClick={clickClose}>
        <img src={require('../../assets/close-big.png')} />
      </div>
      <ContactStepsIndicator 
        index={currentIndex} 
        gotoIndex={nextStep}
      />
      <BookDemoWrap 
        nextStep={nextStep}
        index={indexBack}
        img={tazza}
      >
      </BookDemoWrap>
      <Loader arrayLoad={arrayLoad}/>
    </React.Fragment>
  );
};

export default BookDemoContainer;
